import { render, staticRenderFns } from "./ShangbiaoCategory.vue?vue&type=template&id=755c75be&scoped=true"
import script from "./ShangbiaoCategory.vue?vue&type=script&lang=js"
export * from "./ShangbiaoCategory.vue?vue&type=script&lang=js"
import style0 from "./ShangbiaoCategory.vue?vue&type=style&index=0&id=755c75be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c75be",
  null
  
)

export default component.exports